import axios from '../custom-axios/axios'

class DbpediaLookupRepository {

    search = (term) => {
        return axios.get('/dbpediaLookup', {
            params: {
                'term': term
            }
        });
    }
}

export default new DbpediaLookupRepository()